import { render } from "./IsoVoyageJordan.vue?vue&type=template&id=27b74f3c"
import script from "./IsoVoyageJordan.vue?vue&type=script&lang=js"
export * from "./IsoVoyageJordan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__